module.exports = __webpack_public_path__ + "static/logo-96f3e93b02da9dd96f131d288daa1bc7.png";